import Columns from "../constants/TableColumns";
import SearchCategories from "../constants/SearchCategories";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import { useState } from "react";
import GroupStafDetail from "./GroupStafDetail";
import useAxios from "../../../../Utils/useAxios";
import updateGroupStafStatus from "../services/updateGroupStafStatus";

const GroupStafList = ({ items, resetState, pending }) => {
  const [selectedGroupStaf, setSelectedGroupStaf] = useState(null);
  const updateSelectedGroupStaf = (data) => setSelectedGroupStaf(data);

  const axiosInstance = useAxios()

  const [detailOpen, setDetailOpen] = useState(false);
  const toggleDetail = () => {
    console.log("toggle");
    setDetailOpen(!detailOpen);
  };

  const toggleActivate = (id) => {
    updateGroupStafStatus(axiosInstance, id).then(() => {
      resetState()
    })
  }

  return (
    <>
      <PengaturanListLayout
        items={items}
        itemColumns={Columns(resetState, toggleDetail, updateSelectedGroupStaf, toggleActivate)}
        searchCategories={SearchCategories}
        pending={pending}
      />
      <GroupStafDetail
        data={selectedGroupStaf}
        isOpen={detailOpen}
        toggle={toggleDetail}
      />
    </>
  );
};
export default GroupStafList;
